import { Paper, PaperProps, Stack } from "@mui/material";
import { mergeSx, Sx } from "utils/sx";

export const EVENT_CARD_WIDTH = 40;

const styles: Sx = theme => ({
    boxShadow: `${theme.shadows.homepageCards[1]}, ${theme.shadows.homepageCards[2]}`,
    backgroundColor: theme.palette.background.low,
    borderRadius: theme.spacing(1),
    borderColor: theme.palette.border.light,
    borderWidth: theme.spacing(.125),
    width: theme.spacing(EVENT_CARD_WIDTH),
    overflow: "hidden",
});

export const EventCard: React.FCWithChildren<PaperProps> = ({ children, sx, ...props }) => {    
    return (
        <Paper variant="outlined" sx={mergeSx(styles, sx)} {...props}>
            <Stack direction="column">
                {children}
            </Stack>
        </Paper>
    );
};
